export default __webpack_public_path__ + "static/media/serendipity.7969ab4d.webp";